import { useMutation, useQueryClient } from '@tanstack/react-query';
import { duplicateEntity } from 'queries/share/duplicateEntity';
import { EDT_KEY } from '@teetsh/app/src/queries/edt/useEDTs';
import { EmploiDuTemps } from '@teetsh/app/src/types/edt';
import { AxiosError } from 'axios';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { CLASSROOMS_KEY } from '@teetsh/app/src/queries/classrooms/useClassrooms';
import { useTranslation } from 'react-i18next';
import { Classroom } from 'types/classroom';

interface DuplicatePayload {
  edt: EmploiDuTemps;
  newClassrooms: Classroom[];
}

export function useDuplicateSharedEDT() {
  const { notifyError } = useNotification();
  const { t } = useTranslation(['emploiDuTemps']);
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation<
    DuplicatePayload,
    AxiosError,
    {
      token: string;
      weektableId: string;
      classroomsMapping: Array<{ from: string; to?: string }>;
      destSchoolyearId: string;
      destSchoolId: string;
    }
  >({
    mutationFn: ({ token, weektableId, classroomsMapping, destSchoolId }) =>
      duplicateEntity({
        token,
        entityId: weektableId,
        entityType: 'emploiDuTemps',
        destSchoolId,
        classroomsMapping,
      }),
    onSuccess: (_, { destSchoolyearId, destSchoolId }) => {
      queryClient.invalidateQueries({
        queryKey: [destSchoolyearId],
      });
      queryClient.invalidateQueries({
        queryKey: [CLASSROOMS_KEY, destSchoolId],
      });
      // useless in that case?
      queryClient.invalidateQueries({
        queryKey: [destSchoolyearId, destSchoolId, EDT_KEY, 'list'],
      });
    },
    onError: (_, { destSchoolyearId, destSchoolId }) => {
      queryClient.invalidateQueries({
        queryKey: [destSchoolyearId, destSchoolId, EDT_KEY, 'list'],
      });
      notifyError({
        title: t('emploiDuTemps:messages.edt.createError'),
      });
    },
  });
  return mutateAsync;
}
